module.exports = __webpack_public_path__ + "static/media/bifurcation.b2bbcd7d.svg";